import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup';
import { ErrorMessage } from '@hookform/error-message';
import addressValidation from '../Validation/AddressValidaton';
import useMakeRequest from '../utils/ApiHelper';
import { ApiTypes } from '../constants/Constants';
import { ApiConstants } from '../constants/ApiConstants';
import FrontLoader from '../component/layout/FrontLoader';
import { useNavigate } from 'react-router-dom';
import LocationInput from '../component/address/LocationInput';
import { encodeID } from '../utils/Helper';
import { LanguageConstants } from '../constants/LanguageConstants';

interface FormInputs {
    street_line: string;
    appartment: string;
    state:string;
    city:string;
    zip_code:string;
    loaction_type:string;
    instructions:string
  };

function NewAddress(prop :any) {

    const addressAdd  = useMakeRequest()
    const cityList = useMakeRequest()
    const stateList = useMakeRequest()
    const addressUpdate = useMakeRequest()
    const navigate = useNavigate()
    const [latitude, setLatitude]: any = useState(null)
    const [longitude, setLongitude]: any = useState(null)
    
    const { register, watch, setValue, formState: { errors }, handleSubmit } = useForm<FormInputs>({
        mode: 'onChange',
        resolver: yupResolver(addressValidation),
      });
      const onSubmit = (payload: FormInputs) => {
        addressAdd.makeRequest({ payload, type:ApiTypes.POST, url: ApiConstants?.AddressAdd, toastStatus: true })
     }

     const getUserLocation = () => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              // save the geolocation coordinates in two variables
              const { latitude, longitude } = position.coords;
              setLatitude(latitude);
              setLongitude(longitude);
            },
            (error) => {
              console.error('Error getting user location:', error);
            }
          );
        }
        else {
          console.error('Geolocation is not supported by this browser.');
        }
      };


    useEffect(()=>{
        console.log(getUserLocation())
        stateList.makeRequest({url: ApiConstants?.StateList, toastStatus: false })
    },[])
    useEffect(()=>{
    if(addressAdd?.status){
        if(prop?.data){
            const payload ={
                address_id:addressAdd?.data?.data?.id,
                quotation_id:prop?.data?.quotation_id
            }
        addressUpdate.makeRequest({payload, url: ApiConstants?.QuotesAddressUpdate, toastStatus: true })
        setTimeout(() => {
            prop.handleClose()
            navigate('/my-quotation')
            window.location.reload()
        }, 2000); 
        }else{
            prop.handleClose()
            window.location.reload()
        }
    }
    },[watch('state') , addressAdd.status])

    const handleLocationSuccess = (result: any) => {
        setLatitude(result?.latitudeLongitude?.lat)
        setLongitude(result?.latitudeLongitude?.lng)
        setValue('street_line', result?.formattedAddress)
    }
    const handleLocationStateSuccess = (result: any) => {
        setLatitude(result?.latitudeLongitude?.lat)
        setLongitude(result?.latitudeLongitude?.lng)
        setValue('state', result?.formattedAddress)
    }
    const handleLocationCitySuccess = (result: any) => {
        setLatitude(result?.latitudeLongitude?.lat)
        setLongitude(result?.latitudeLongitude?.lng)
        setValue('city', result?.formattedAddress)
    }

  return (
      <>
      {addressAdd?.loading ? <FrontLoader/> : null }
     <div className="modal fade com-modal short-modal text-center show" id="newAddressModal" aria-labelledby="newAddressModalLabel"  aria-hidden="true" style={{display: "block"}} >
                <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="newAddressModalLabel">{LanguageConstants?.NEWADDRES}</h5>
                            <button onClick={()=>prop.handleClose()} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="icon-close-square" /></button>
                        </div>
                        <div className="modal-body pb-0 text-start">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="com-input-wrap mb-3">
                                <label className="form-label">{LanguageConstants?.STREE_LINE}<span className="">*</span></label>
                                <LocationInput
                                                id='home-pickup-input'
                                                className="form-control exclamation-bg"
                                                onSuccess={handleLocationSuccess}
                                                value={watch("street_line")}
                                                placeholder={`${LanguageConstants?.ENTER_STREE_LINE}`}
                                                onChange={(e) => {
                                                setValue('street_line', e?.target?.value)
                                            }}
                                            />
                                {/* <input type="text" className="form-control" placeholder="Enter street line" {...register('street_line')} /> */}
                                <ErrorMessage
                                    errors={errors}
                                    name="street_line"
                                    render={({ message }) => <p className='text-error-new'>{message}</p>}
                                />
                            </div>
                            {/* <div className="com-input-wrap mb-3">
                                <label className="form-label">{LanguageConstants?.APRATMENT}<span className=""></span></label>
                                <input type="text" className="form-control" placeholder={LanguageConstants?.ENTER_APARTMENT} {...register('appartment')}/>
                                <ErrorMessage
                                    errors={errors}
                                    name="appartment"
                                    render={({ message }) => <p className='text-error-new'>{message}</p>}
                                />
                            </div> */}
                              <div className="com-input-wrap mb-3">
                                                            <label className="form-label">{LanguageConstants?.INSTRUCTIONS}<span className=""></span></label>
                                                            <input type="text" className="form-control" placeholder={LanguageConstants?.ENTER_INSTRUCTIONS} {...register('instructions')}/>
                                                            <ErrorMessage
                                                                errors={errors}
                                                                name="instructions"
                                                                render={({ message }) => <p className='text-error-new'>{message}</p>}
                                                            />
                                        </div>
                            <div className="com-input-wrap mb-3">
                                <label className="form-label">{LanguageConstants?.ZIP_CODE}</label>
                                <input type="text" className="form-control" placeholder={LanguageConstants?.ENTER_ZIP_CODE} {...register('zip_code')}/>
                                <ErrorMessage
                                    errors={errors}
                                    name="zip_code"
                                    render={({ message }) => <p className='text-error-new'>{message}</p>}
                                />
                            </div>
                            <div className="com-input-wrap mb-3">
                                <label className="form-label">{LanguageConstants?.LOACTION_TYPE}*</label>
                                <select
                                        className="form-select"
                                        aria-label="Default select example"
                                        {...register('loaction_type')}
                                        >
                                       <option selected value={''} >{LanguageConstants?.LOACTION_TYPE}</option>
                                       <option  value='1' >{LanguageConstants?.RESIDENTIAL}</option>
                                       <option  value='2' >{LanguageConstants?.LABORAL}</option>
                                    </select>
                                    <ErrorMessage
                                    errors={errors}
                                    name="loaction_type"
                                    render={({ message }) => <p className='text-error-new'>{message}</p>}
                                />
                            </div>

                        <div className="modal-footer">
                            <button type="submit" className="round-btn m-0 w-100" >{LanguageConstants?.COUNTINUE}</button>
                        </div>
                        </form>
                        </div>
                    </div>
                </div>
     </div>
    </>
  )
}

export default NewAddress